import { render, staticRenderFns } from "./LottoTrxForm.vue?vue&type=template&id=b295e1b2&scoped=true&"
import script from "./LottoTrxForm.vue?vue&type=script&lang=js&"
export * from "./LottoTrxForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b295e1b2",
  null
  
)

export default component.exports